import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { wpiTheme } from "./wpiTheme";

export const CustomButton = styled(Button)(({ theme }) => ({
    'background-color': wpiTheme.color,
    ':hover': {
        'background-color': wpiTheme.hoverColor
    }
}))